import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'lib-scope-name',
  template: `
    @if ({ row: columnData | async }; as $) {
      <div>
        @if ($.row?.scope_name) {
          <div class="font-medium">
            @if (getScopeNameLength($.row?.scope_name) <= 50) {
              <span>{{ $.row?.scope_name }}</span>
            }
            @if (getScopeNameLength($.row?.scope_name) > 50) {
              <span>
                {{ getTruncatedScopeName($.row?.scope_name) }}
                <span class="text-primary ml-1" style="text-decoration: underline;">...show more</span>
              </span>
            }
          </div>
        }
        @if ($.row?.scope_sku_name && getScopeNameLength($.row?.scope_sku_name) <= 50) {
          <div class="text-sm text-500">
            SKU: {{ $.row?.scope_sku_name }}
          </div>
        }
        @if ($.row?.scope_sku_name && getScopeNameLength($.row?.scope_sku_name) > 50) {
          <div class="text-sm text-500">
            SKU: {{ getTruncatedScopeName($.row?.scope_sku_name) }}
          </div>
        }
        @if (!$.row?.scope_name && !$.row?.scope_sku_name) {
          <div class="text-500">-</div>
        }
      </div>
    }
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe]
})
export class ScopeNameComponent {
  columnData: Observable<any> = new BehaviorSubject<any>(null);
  additionData: Observable<any> = new BehaviorSubject<any>(null);

  getScopeNameLength(scopeName: string | null | undefined): number {
    return scopeName ? scopeName.length : 0;
  }

  getTruncatedScopeName(scopeName: string | null | undefined): string {
    if (!scopeName) return '';
    return scopeName.length > 50 ? scopeName.substring(0, 50) : scopeName;
  }
}


